<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    tags () {
      return this.$store.getters.tags
    }
  },
  methods: {
    getTags (id) {
      this.$store.dispatch('getTags', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTags(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tag.vue?a0a54f5a